/**
 * @author liujf
 * @create date 2018-09-10
 * @desc 通过指令移动组件到body下(参考：iview下transfer-dom.js)
*/
//若是需要绑定到指定dom下，可通过绑定CSS选择器
//使用方法 v-transfer-dom :data-transfer="transfer"

function getTarget (node) {
    if (node === undefined) {
        node = document.body
    }
    return node instanceof window.Node ? node : document.querySelector(node)
}

const directive = {
    inserted (el, {value}) {
        if (el.dataset && !el.dataset.transfer) { return }
        const parentNode = el.parentNode
        if (!parentNode) { return }
        el.className = el.className ? el.className + ' v-transfer-dom' : 'v-transfer-dom'
        const home = document.createComment('dom') //创建注释
        let hasMovedOut = false
        let target
        
        if (value || value === undefined) {
            target = getTarget(value)
            if (!target) {
                return
            }
            parentNode.replaceChild(home, el) //将原来节点改为注释
            target.appendChild(el)
            hasMovedOut = true
        }
        if (!el.__transferData) {
            el.__transferData = {
                home,
                parentNode,
                target,
                hasMovedOut
            }
        }
    },
    componentUpdated (el, {value}) {
        if (el.dataset && !el.dataset.transfer) { return }
        const domData = el.__transferData
        let home, parentNode, hasMovedOut
        if (!domData) { 
            home = document.createComment('dom') //创建注释
            parentNode = el.parentNode
            hasMovedOut = false
        } else {
            home = domData.home
            parentNode = domData.parentNode
            hasMovedOut = domData.hasMovedOut
        }
        
        let target
        if (value || value === undefined) {
            target = getTarget(value)
            if (!target) {
                return
            }
        }
        
        if (!hasMovedOut && target) {
            parentNode.replaceChild(home, el) //将原来节点改为注释
            target.appendChild(el)
            el.__tranferData = Object.assign({}, domData, {hasMovedOut: true, target: target})
        } 
        else if (hasMovedOut && value === false) {
            parentNode.replaceChild(el, home)
            el.__tranferData = Object.assign({}, domData, {hasMovedOut: false, target: target})
        }
    },
    unbind (el, {value}) {
        if (el.dataset && !el.dataset.transfer) { return }
        const domData = el.__transferData
        if (!domData) { return }
        el.className = el.className.replace('v-transfer-dom', '')
        const home = domData.home
        const parentNode = domData.parentNode
        const hasMovedOut = domData.hasMovedOut
        if (hasMovedOut) {
            parentNode.appendChild(el)
        }
        el.__transferData = null
    }
}

export default directive
